import { TypeService } from '@thewhite/react-global-module/lib/services';
import { DictionaryItemParams } from '../interfaces/dictionaryItemParams';

export enum DictionariesEnum {
    ACTIVITY_CATEGORY = 'ACTIVITY_CATEGORY',
    SERVICE_CATEGORY = 'SERVICE_CATEGORY',
    INTEREST = 'INTEREST',
    SOCIAL_STATUS = 'SOCIAL_STATUS',
    PROFESSION = 'PROFESSION',
    REGISTRY_DOCUMENT_TYPE = 'REGISTRY_DOCUMENT_TYPE',
    DictionaryItemParams = 'DictionaryItemParams',
};

export interface DictionariesParams {
    [value: string]: DictionaryItemParams;

    ACTIVITY_CATEGORY: DictionaryItemParams;
    SERVICE_CATEGORY: DictionaryItemParams;
    INTEREST: DictionaryItemParams;
    SOCIAL_STATUS: DictionaryItemParams;
    ORGANIZATION_CATEGORY: DictionaryItemParams;
    PROFESSION: DictionaryItemParams;
    REGISTRY_DOCUMENT_TYPE: DictionaryItemParams;
    RETAIL_CHAINS: DictionaryItemParams;
};

const DICTIONARIES: DictionariesParams = {
    ACTIVITY_CATEGORY: {
        path: 'activity-category',
        value: 'ACTIVITY_CATEGORY',
        name: 'Категории активностей',
    },
    SERVICE_CATEGORY: {
        path: 'service-category',
        value: 'SERVICE_CATEGORY',
        name: 'Категории услуг',
    },
    INTEREST: {
        path: 'interest',
        value: 'INTEREST',
        name: 'Интересы',
    },
    SOCIAL_STATUS: {
        path: 'social-status',
        value: 'SOCIAL_STATUS',
        name: 'Социальные статусы',
    },
    ORGANIZATION_CATEGORY: {
        path: 'organization-category',
        value: 'ORGANIZATION_CATEGORY',
        name: 'Категории организаций',
    },
    PROFESSION: {
        path: 'profession',
        value: 'PROFESSION',
        name: 'Виды деятельности',
    },
    REGISTRY_DOCUMENT_TYPE: {
        path: 'registry-document-type',
        value: 'REGISTRY_DOCUMENT_TYPE',
        name: 'Виды документов для регистрации',
    },
    ACtIVITY_DOCUMENT_TYPE: {
        path: 'activity-document-type',
        value: 'ACtIVITY_DOCUMENT_TYPE',
        name: 'Виды документов для заявок',
    },
    RETAIL_CHAINS: {
        path: 'retail-chains',
        value: 'RETAIL_CHAINS',
        name: 'Торговые сети',
    },
};

export default DICTIONARIES;

export const DictionariesType = TypeService.createEnum<DictionariesEnum>(DictionariesEnum, 'DictionariesEnum');
